import {
	PAGE_SET,
	PAGE_RESET_MESSAGE,
	PAGES_FETCH_REQUEST,
	PAGES_FETCH_FAILURE,
	PAGES_FETCH_SUCCESS,
	PAGE_FETCH_REQUEST,
	PAGE_FETCH_FAILURE,
	PAGE_FETCH_SUCCESS,
	PAGE_UPDATE_REQUEST,
	PAGE_UPDATE_FAILURE,
	PAGE_UPDATE_SUCCESS,
	PAGE_CREATE_REQUEST,
	PAGE_CREATE_FAILURE,
	PAGE_CREATE_SUCCESS,
	PAGE_DELETE_REQUEST,
	PAGE_DELETE_FAILURE,
	PAGE_DELETE_SUCCESS,
} from '../constants/actionTypes';

const initialState = {
	isFetching: false,
	isUpdating: false,
	isCreating: false,
	isDeleting: false,
	message: {
		type: '',
		text: '',
	},
	selected: false,
};

export default function pages(state = initialState, action) {
	const { type, payload } = action;

	switch (type) {
		case PAGE_SET:
			return {
				...state,
				selected: Number(payload.id),
			};

		case PAGE_RESET_MESSAGE:
			return {
				...state,
				message: {
					type: '',
					text: '',
				},
			};

		case PAGES_FETCH_REQUEST:
			return {
				...state,
				isFetching: true,
				message: {
					type: '',
					text: '',
				},
			};

		case PAGES_FETCH_FAILURE:
			return {
				...state,
				isFetching: false,
				message: {
					type: 'error',
					text: payload.message,
				},
			};

		case PAGES_FETCH_SUCCESS:
			return {
				...state,
				isFetching: false,
				message: {
					type: 'success',
					text: '',
				},
			};

		case PAGE_FETCH_REQUEST:
			return {
				...state,
				isFetching: true,
				selected: false,
				message: {
					type: '',
					text: '',
				},
			};

		case PAGE_FETCH_FAILURE:
			return {
				...state,
				isFetching: false,
				message: {
					type: 'error',
					text: payload.message,
				},
				selected: false,
			};

		case PAGE_FETCH_SUCCESS:
			return {
				...state,
				isFetching: false,
				selected: Number(payload.page),
				message: {
					type: 'success',
					text: '',
				},
			};

		case PAGE_UPDATE_REQUEST:
			return {
				...state,
				isUpdating: true,
				message: {
					type: '',
					text: '',
				},
			};

		case PAGE_UPDATE_FAILURE:
			return {
				...state,
				message: {
					type: 'error',
					text: payload.message,
				},
				isUpdating: false,
			};
		case PAGE_UPDATE_SUCCESS:
			return {
				...state,
				isUpdating: false,
				message: {
					type: 'success',
					text: payload.message,
				},
			};

		case PAGE_CREATE_REQUEST:
			return {
				...state,
				isCreating: true,
				message: {
					type: '',
					text: '',
				},
			};

		case PAGE_CREATE_FAILURE:
			return {
				...state,
				isCreating: false,
				message: {
					type: 'error',
					text: payload.message,
				},
			};

		case PAGE_CREATE_SUCCESS:
			return {
				...state,
				isCreating: false,
				message: {
					type: 'success',
					text: payload.message,
				},
			};

		case PAGE_DELETE_REQUEST:
			return {
				...state,
				isDeleting: true,
				message: {
					type: '',
					text: '',
				},
			};

		case PAGE_DELETE_FAILURE:
			return {
				...state,
				isDeleting: true,
				message: {
					type: 'error',
					text: payload.message,
				},
			};

		case PAGE_DELETE_SUCCESS:
			return {
				...state,
				isDeleting: false,
				message: {
					type: 'success',
					text: '',
				},
			};

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/pages.js